import { sortingMethods } from '../../../../constants/table';
import CustomCell from '../../../../components/Table/CustomCell';
import { PORTAL_ROUTE } from '../../../../constants/routes';

export const scriptExecutionTableColumnsOrder = [
  { name: 'fileName', styles: { wordBreak: 'break-word' } },
  { name: 'filePath', styles: { wordBreak: 'break-word' } },
  { name: 'sha256Hash', styles: { wordBreak: 'break-word' } },
  { name: 'deviceCount' },
  { name: 'lastSeen' },
];

export const scriptExecutionTableHeadings = [
  {
    title: 'Script Name',
    name: 'fileName',
    hasSorting: true,
    width: '24%',
    sortMethod: sortingMethods.initial,
    field: 'FilterScriptExecutionResult',
    sortingCellField: 'FileName',
    sortFieldName: 'OrderQuery',
    Component: CustomCell,
  },
  {
    title: 'File Path',
    name: 'filePath',
    sortMethod: sortingMethods.initial,
    hasSorting: true,
    Component: CustomCell,
    field: 'FilterScriptExecutionResult',
    sortingCellField: 'FilePath',
    sortFieldName: 'OrderQuery',
    width: '25%',
  },
  {
    title: 'SHA256 HASH',
    name: 'sha256Hash',
    hasSorting: true,
    width: '18%',
    sortMethod: sortingMethods.initial,
    field: 'FilterScriptExecutionResult',
    sortingCellField: 'Sha256Hash',
    sortFieldName: 'OrderQuery',
    Component: CustomCell,
  },
  {
    title: 'Device Count',
    name: 'DeviceCount',
    hasSorting: true,
    width: '18%',
    sortMethod: sortingMethods.initial,
    field: 'FilterScriptExecutionResult',
    sortingCellField: 'DeviceCount',
    sortFieldName: 'OrderQuery',
    Component: CustomCell,
  },
  {
    title: 'Last Seen',
    name: 'lastSeen',
    hasSorting: true,
    width: '18%',
    sortMethod: sortingMethods.initial,
    field: 'FilterScriptExecutionResult',
    sortingCellField: 'LastSeen',
    sortFieldName: 'OrderQuery',
    Component: CustomCell,
  },
];

export const scriptExecutionSidebarList = [
  {
    title: 'Date Filter',
    name: 'DateRange',
    type: 'dateRange',
  },
  {
    title: 'User Writeable',
    name: 'Filter',
  },
];

export const wdacScriptExecutionTabs = (scriptExecutionId, counts) => [
  {
    label: `Details`,
    value: `${PORTAL_ROUTE}/script-execution-details/${scriptExecutionId}/details`,
  },
  {
    label: `Devices (${counts || 0})`,
    value: `${PORTAL_ROUTE}/script-execution-details/${scriptExecutionId}/devices`,
  },
];

export const WDAC_SCRIPT_EXECUTION_PREVIOUS_PATH = 'wdacScriptExecution';
